import { useState, useEffect } from "react";

import moment from "moment";

import { doc, collection, query, where, onSnapshot } from "firebase/firestore";

// import { doc, getDoc } from "firebase/firestore";

import { useParams, Link, useHistory } from "react-router-dom";
import { firestore } from "../firebase";
import firebase from "firebase/compat/app";
import { useUserProvider } from "../context/UserProvider";
import { collectIdsAndDocs } from "../utils";

import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import TimelapseIcon from "@mui/icons-material/Timelapse";
import AddIcon from "@mui/icons-material/Add";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

import EditIcon from "@mui/icons-material/Edit";

import {
  Button,
  MenuItem,
  Box,
  Grid,
  Stack,
  Divider,
  Typography,
  Tab,
  Tabs,
} from "@mui/material";
import Sites from "./Sites";

import MeasurementDetail from "./MeasurementDetail";
import Measurements from "./Measurements";

const tabs = [
  { label: "Details", value: "details" },
  // { label: "Measurements", value: "measurements" },
];

function HeaderSingleMeasurement(props) {
  const existingField = [
    props.formData.typeOfNoise,
    props.formData.directionOfEmission,
    props.formData.typeOfNoise,
    props.formData.spectrumOfMeasurements,
    props.formData.DnTw_100_3150Hz,
    props.formData.C_100_3150Hz,
    props.formData.CTR_100_3150Hz,
    props.formData.cs_100Hz,
    props.formData.cs_125Hz,
    props.formData.cs_160Hz,
    props.formData.cs_200Hz,
    props.formData.cs_250Hz,
    props.formData.cs_315Hz,
    props.formData.cs_400Hz,
    props.formData.cs_500Hz,
    props.formData.cs_630Hz,
    props.formData.cs_800Hz,
    props.formData.cs_1000Hz,
    props.formData.cs_1250Hz,
    props.formData.cs_1600Hz,
    props.formData.cs_2000Hz,
    props.formData.cs_2500Hz,
    props.formData.cs_3150Hz,
  ];

  function isEmptyString(operand) {
    return operand != "" ? "full" : "empty";
  }

  function isEmpty(current) {
    return isEmptyString(current) === "full" ? true : false;
  }

  const [currentTab, setCurrentTab] = useState("details");

  const [measurements, setMeasurements] = useState([]);
  // const { id } = useParams();
  const { user } = useUserProvider();

  // const siteRef = firestore.doc(`sites/${siteId}`);
  // const wallsRef = siteRef.collection("walls");

  // const siteRef = firestore.doc(`sites/${siteId}`);
  const wallRef = firestore.doc(`sites/${props.siteId}/walls/${props.wallId}`);
  const measurementsRef = wallRef.collection("measurements");

  let unsubscribeFromMeasurement = null;

  useEffect(() => {
    unsubscribeFromMeasurement = measurementsRef.onSnapshot((snapshot) => {
      const measurements = snapshot.docs.map(collectIdsAndDocs);
      setMeasurements(measurements);
    });

    return () => {
      unsubscribeFromMeasurement();
    };
  }, []);

  // const siteRef = firestore.doc(`sites/${siteId}`);
  // const wallsRef = siteRef.collection("walls");

  // const siteRef = firestore.doc(`sites/${siteId}`);
  // const wallRef = firestore.doc(`sites/${props.siteId}/walls/${props.wallId}`);
  // const measurementsRef = wallRef.collection("measurements");

  // let unsubscribeFromMeasurement = null;

  // useEffect(() => {
  //   unsubscribeFromMeasurement = measurementsRef.onSnapshot((snapshot) => {
  //     const measurements = snapshot.docs.map(collectIdsAndDocs);
  //     setMeasurements(measurements);
  //   });

  //   return () => {
  //     unsubscribeFromMeasurement();
  //   };
  // }, []);

  // const wallRef = wallsRef.doc(`walls/${id}`);
  // const wallRef = firestore.doc(`sites/mdfAar5ZWmIbVJ9sdOfu/walls/${id}`);

  // let unsubscribeFromWall = null;

  // useEffect(() => {
  //   unsubscribeFromWall = wallRef.onSnapshot((snapshot) => {
  //     const wall = collectIdsAndDocs(snapshot);
  //     setWall(wall);
  //   });
  //   return () => {
  //     unsubscribeFromWall();
  //   };
  // }, []);

  const handleTabsChange = (event, value) => {
    setCurrentTab(value);
  };

  const createdAt = props.createdAt;

  const { nanoseconds, seconds } = createdAt !== null && createdAt;
  var timestamp = { nanoseconds, seconds };
  const dateTime = new Date(timestamp?.seconds * 1000);

  return (
    <Box sx={{ pb: 0 }}>
      <Box sx={{ mt: -2, mb: 2 }}>
        <MenuItem
          className="backlink"
          component={Link}
          sx={{
            p: "0",
          }}
          to={`/sites/${props.siteId}/walls/${props.wallId}`}
          // to="/sites/mdfAar5ZWmIbVJ9sdOfu"
          // to={`/sites/${id}`}s
        >
          <Grid container>
            <Grid
              item
              sx={{
                alignItems: "center",
                display: "flex",
                overflow: "hidden",
                pr: ".5em",
              }}
            >
              <ArrowBackIcon fontSize="small" />
            </Grid>
            <Grid
              item
              sx={{
                alignItems: "center",
                display: "flex",
                overflow: "hidden",
              }}
            >
              <Typography variant="subtitle2">
                {/* {props.siteStreet}, {props.siteNumber} */}Site
              </Typography>
            </Grid>
          </Grid>
        </MenuItem>
      </Box>
      <Grid container justifyContent="space-between" spacing={3}>
        <Grid
          item
          sx={{
            alignItems: "center",
            display: "flex",
            overflow: "hidden",
          }}
        >
          <Box
            sx={{
              mr: 2,
              p: 1,
              backgroundColor: (theme) =>
                theme.palette.mode === "dark" ? "#037AF6" : "#3399ff",
              borderRadius: 2,
              maxWidth: "fit-content",
            }}
          >
            <Typography align="center" color="#fff" variant="subtitle2">
              {moment(dateTime).format("MMM").toUpperCase()}
            </Typography>
            <Typography align="center" color="#fff" variant="h6">
              {moment(dateTime).format("DD").toUpperCase()}
            </Typography>
          </Box>
          <div>
            <Typography variant="h4">
              {props.formData.directionOfEmission}
            </Typography>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              {existingField.every(isEmpty) ? (
                <CheckCircleIcon
                  align="center"
                  fontSize="medium"
                  color="success"
                  sx={{ alignItems: "center", justifyContent: "center" }}
                />
              ) : (
                <TimelapseIcon fontSize="medium" sx={{ color: "#8D9EB7" }} />
              )}
              <Typography variant="subtitle2" sx={{ ml: 1 }}>
                Measurement
              </Typography>
              <Typography
                // color="textSecondary"
                variant="subtitle2"
                sx={{
                  ml: 1,
                  color: (theme) =>
                    theme.palette.mode === "dark"
                      ? "rgb(128, 191, 255)"
                      : "#1b78d5",
                }}
              >
                {props.formData.typeOfNoise}
              </Typography>
              {/* <Typography
                color="textSecondary"
                variant="subtitle2"
                sx={{ ml: 1 }}
              >
                {formData.registrationPeriod}
              </Typography>
              <Typography variant="subtitle2" sx={{ ml: 1 }}>
                {formData.roomDisposalDependingBeforeWorks ||
                  formData.roomDisposalDependingAfterWorks}
              </Typography> */}
            </Box>
          </div>
        </Grid>
        <Grid item>
          <Stack direction="row" spacing={2}>
            {!user ? (
              <Link to="/login" style={{ textDecoration: "none" }}>
                <Button
                  component="a"
                  // endIcon={<EditIcon fontSize="small" />}
                  sx={{ m: 1 }}
                  variant="outlined"
                  size="small"
                >
                  Sign in to edit measure
                </Button>
              </Link>
            ) : (
              <>
                <Link
                  to={{
                    pathname: `/editMeasurement/${props.measurementId}/`,
                    state: { props },
                  }}
                  style={{ textDecoration: "none" }}
                >
                  <Button
                    component="a"
                    endIcon={<EditIcon fontSize="small" />}
                    sx={{ m: 1 }}
                    variant="outlined"
                    className="outlined_2"
                    size="small"
                  >
                    Edit measure
                  </Button>
                </Link>
                {/* <Link
                  to={{
                    pathname: `/addnewmeasurement/${wallId}/`,
                    state: { siteId, wallId },
                  }}
                  style={{ textDecoration: "none" }}
                >
                  <Button
                    component="a"
                    endIcon={<AddIcon fontSize="small" />}
                    sx={{ m: 1 }}
                    variant="contained"
                    size="small"
                  >
                    NEW MEASUREMENT
                  </Button>
                </Link> */}
              </>
            )}
          </Stack>
        </Grid>
      </Grid>
      <Tabs
        indicatorColor="primary"
        onChange={handleTabsChange}
        scrollButtons="auto"
        textColor="primary"
        value={currentTab}
        variant="scrollable"
        sx={{ mt: 3 }}
      >
        {tabs.map((tab) => (
          <Tab
            sx={{ color: "textSecondary" }}
            key={tab.value}
            label={tab.label}
            value={tab.value}
            // component={Link}
            // to={`/walls/${wallId}/${tab.value}`}
          />
        ))}
      </Tabs>
      <Divider sx={{ mb: 3 }} />
      {currentTab === "details" && (
        <MeasurementDetail
          mesurements={measurements}
          formData={props.formData}
          {...measurements}
        />
      )}
      {/* {currentTab === "details" && "lol"} */}
    </Box>
  );
}

export default HeaderSingleMeasurement;
